import React from "react"

const Mail = () => (
	<svg width="18" height="14" xmlns="http://www.w3.org/2000/svg">
		<path
			d="m1 0 8 8 8-8H1Zm17 1-9 9-9-9v12.001c0 .552.445.999.993.999h16.014a.996.996 0 0 0 .993-.999V1Z"
			fill="#FFF"
			fillRule="evenodd"
		/>
	</svg>
)

export default Mail
